module.exports = __webpack_public_path__ + "img/Defs.ccaeac50.png";